import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-27f7bd65"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "loading-container icons"
}
const _hoisted_2 = {
  key: 1,
  class: "icons"
}

import { ref, onMounted } from 'vue'
import CompletedService from '@/services/CompletedService'
import { useAuth } from '@/store/useAuth'
import main from '@/data/main.js';


export default /*#__PURE__*/_defineComponent({
  __name: 'LessonChecker',
  props: ['lessonId'],
  setup(__props, { expose: __expose }) {

const loading = ref(true)
const completedService = new CompletedService()
const store = useAuth()
const props = __props
const isCompleted = ref()

onMounted(async () => {
    if(!store.token) {
        loading.value = false
        return
    }

    loading.value = true
    isCompleted.value = await completedService.checkCompletedStatus(store.token, props.lessonId)
    loading.value = false
})

const updateStatus = async () => {
    if(!store.token) {
        loading.value = false
        return
    }

    loading.value = true
    isCompleted.value = await completedService.checkCompletedStatus(store.token, props.lessonId)
    loading.value = false
}

__expose({updateStatus})

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (loading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_v_icon, {
          name: "ri-loader-2-fill",
          animation: "spin",
          class: "icon",
          scale: "1"
        })
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        (isCompleted.value)
          ? (_openBlock(), _createBlock(_component_v_icon, {
              key: 0,
              name: "bi-check-circle-fill",
              fill: _unref(main).THIRD_COLOR
            }, null, 8, ["fill"]))
          : (_openBlock(), _createBlock(_component_v_icon, {
              key: 1,
              name: "bi-circle"
            }))
      ]))
}
}

})